import React from "react";

import { CONTACT_DETAILS } from "../../data/content";

//Round grey Facebook / Instagram icons, as on Wix
const LINKS = [
  {
    label: "Beechwood Gardens on Facebook",
    href: CONTACT_DETAILS.FACEBOOK_LINK,
    path: "M13.4 20v-7.1h2.4l.36-2.78H13.4V8.35c0-.8.22-1.35 1.38-1.35h1.47V4.51c-.25-.03-1.13-.11-2.14-.11-2.12 0-3.57 1.29-3.57 3.67v2.05H8.14v2.78h2.4V20h2.86z",
  },
  {
    label: "Beechwood Gardens on Instagram",
    href: CONTACT_DETAILS.INSTAGRAM_LINK,
    path: "M12 7.2c1.56 0 1.75 0 2.37.03 1.6.07 2.33.83 2.4 2.4.03.61.04.8.04 2.37s0 1.75-.04 2.37c-.07 1.56-.8 2.33-2.4 2.4-.62.03-.8.04-2.37.04s-1.75 0-2.37-.04c-1.6-.07-2.33-.84-2.4-2.4-.03-.62-.04-.8-.04-2.37s0-1.75.04-2.37c.07-1.57.8-2.33 2.4-2.4.62-.03.8-.03 2.37-.03zM12 6.14c-1.59 0-1.79 0-2.42.04-2.13.1-3.31 1.28-3.41 3.41-.03.63-.04.83-.04 2.42s0 1.79.04 2.42c.1 2.13 1.28 3.31 3.41 3.41.63.03.83.04 2.42.04s1.79 0 2.42-.04c2.12-.1 3.32-1.28 3.41-3.41.03-.63.04-.83.04-2.42s0-1.79-.04-2.42c-.1-2.12-1.28-3.31-3.41-3.41-.63-.03-.83-.04-2.42-.04zm0 2.85a3.01 3.01 0 1 0 0 6.02 3.01 3.01 0 0 0 0-6.02zm0 4.96a1.95 1.95 0 1 1 0-3.9 1.95 1.95 0 0 1 0 3.9zm3.13-5.78a.7.7 0 1 0 0 1.41.7.7 0 0 0 0-1.41z",
  },
];

const SocialIcons = ({ className = "" }) => (
  <ul className={`social-icons ${className}`}>
    {LINKS.map((link) => (
      <li key={link.href}>
        <a
          href={link.href}
          target={"_blank"}
          rel={"noopener noreferrer"}
          aria-label={link.label}
          className={"social-icon"}
        >
          <svg
            viewBox={"0 0 24 24"}
            aria-hidden={"true"}
            focusable={"false"}
          >
            <circle
              cx={"12"}
              cy={"12"}
              r={"12"}
            />
            <path d={link.path} />
          </svg>
        </a>
      </li>
    ))}
  </ul>
);

export default SocialIcons;
